module.exports = __webpack_public_path__ + "static/img/bg_2.7b7ff6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs/bg_2.jpg
// module id = ZnNU
// module chunks = 0